import { findPromotes } from '../../services/promote';

export const FETCH_PROMOTES = 'FETCH_PROMOTES';



export const fetchPromotes = (params) => {

    return {
        type: FETCH_PROMOTES,
        payload: {
            promise: findPromotes(params),
        },
        meta: {
            searchParams: params,
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/promote.js